module.exports = __webpack_public_path__ + "static/media/noxx-bio.780afab4.pdf";